"use client"

import { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { AnimatePresence, motion } from "framer-motion"
import { useLoadingIndicatorStore } from "./store/useLoadingIndicatorStore"
import LoadingIndicator from "./LoadingIndicator"

export default function LoadingIndicatorPortal() {
  const { isOpen, isDimmed } = useLoadingIndicatorStore()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  const overlayRoot = document.getElementById("loading-indicator-root")

  if (!overlayRoot || !mounted) return null

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={`pointer-events-auto fixed inset-0 z-10000 flex w-full items-center justify-center ${isDimmed ? "bg-black/40" : ""} `}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={() => {}}
        >
          <motion.div
            className="flex w-full items-center justify-center"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <LoadingIndicator />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    overlayRoot as Element,
  )
}
